var React = require('react');

function FilterCaretDropdown (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":"0.6"},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.7498 3.21806C12.0834 3.53041 12.0834 4.05427 11.7498 4.36662L6 9.75L0.250208 4.36662C-0.0834025 4.05427 -0.0834025 3.53041 0.250208 3.21806C0.560742 2.92731 1.04815 2.92731 1.35868 3.21806L6 7.5636L10.6413 3.21806C10.9519 2.92731 11.4393 2.92731 11.7498 3.21806Z","fill":"#E8EFFF"})));
}

FilterCaretDropdown.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = FilterCaretDropdown;

FilterCaretDropdown.default = FilterCaretDropdown;
